import styled from 'styled-components';

export const FormValidationMessage = styled.div`
  color: ${({ theme }) => theme.palette.error};
  font-size: 1.2rem;
  margin-left: 0.5rem;
`;
